import * as yup from 'yup'
import messages from './messages.json'


export const forgot = () => yup.object({
  username: yup.string().email().required(messages.required)
})
